export default {
  'pages.rc.80620': '日历名称重复',
  'pages.rc.1033': '用户名或密码错误，请重新输入',
  'pages.rc.1029': '用户名或密码错误，请重新输入'
};
